import React, { Component } from 'react';
import Form from 'components/react-validation/components/form';
import * as Vali from 'helper/validator-helper';
import { AppSettings } from '../../constants';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/Dropdown/Dropdown';
// import Radio from 'components/CustomRadio/CustomRadio';
import Input from 'components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
// import { GeoComplete } from '../../components/geo-complete/index';
import { PlacesWithStandaloneSearchBox } from 'components/geo-complete/CustomMap';
import * as ProjectActionType from '../constants';
import isEqual from 'lodash/isEqual';
// import isEmpty from 'lodash/isEmpty';
import Translate from 'components/translate';
import PhoneNumberInput from 'components/PhoneNumberInput';
import auth from 'Auth/authenticator';
import TagsInput from '../../components/tag-input';
import SiteOneModal from '../../components/modal';
import { Modal } from 'react-bootstrap';

export class ProjectAddEditInformation extends Component {
  static propTypes = {
    item: PropTypes.object,
    errorMsg: PropTypes.array,
    isCreate: PropTypes.bool,
    onBindingAccount: PropTypes.func,
    selectListAccounts: PropTypes.array
  };
  constructor(props) {
    super(props);

    this.hasLoaded = false;

    this.location = {
      fullLocation: '',
      city: '',
      state: '',
      postalCode: ''
    };

    this.state = {
      project: {
        name: props.item.name ? props.item.name : '',
        emergencyPhone: props.item.emergencyPhone
          ? props.item.emergencyPhone
          : '',
        fullLocation: props.item.fullLocation ? props.item.fullLocation : '',
        city: props.item.city ? props.item.city : '',
        state: props.item.state ? props.item.state : '',
        postalCode: props.item.postalCode ? props.item.postalCode : '',
        costCode: props.item.costCode ? props.item.costCode : '',
        status: props.item.status
      },
      selectedOwner: null,
      originProjectOwnerId: null,
      region: null,
      costCodeArr: props.item.costCode ? props.item.costCode.split('|').filter(x => x) : [],
      market: null,
      isFetchedRegion: false,
      isFetchedMarket: false,
      errorMsg: props.errorMsg,
      errorMessage: '',
      initialed: false,
      confirmationModal: false,
      modalContent: "",
      nameNochanged: false
    };
  }
  /* eslint-disable */
  componentWillReceiveProps(nextProps) {
    let { project } = this.state;
    if (!isEqual(nextProps.item, this.props.item)) {
      // let values = this.mapParam();
      project.name = nextProps.item.name;
      project.emergencyPhone = nextProps.item.emergencyPhone;
      project.fullLocation = nextProps.item.fullLocation;
      project.city = nextProps.item.city;
      project.state = nextProps.item.state;
      project.postalCode = nextProps.item.postalCode;
      project.costCode = nextProps.item.costCode;
      project.status = nextProps.item.status;
      this.setState({
        project,
        costCodeArr: project.costCode.split('|').filter(x => x),
        originProjectOwnerId: nextProps.item.projectOwnerId,
      });
    }

    if (
      !nextProps.isCreate &&
      nextProps.selectListAccounts &&
      nextProps.item.projectOwnerId
    ) {
      if (
        !this.state.selectedOwner ||
        (this.state.selectedOwner &&
          nextProps.item.projectOwnerId !== this.state.selectedOwner.value &&
          this.state.originProjectOwnerId &&
          nextProps.item.projectOwnerId !== this.state.originProjectOwnerId)
      ) {
        this.setState({
          selectedOwner: {
            value: nextProps.item.projectOwner.id,
            text: nextProps.item.projectOwner.displayName,
            extensionValue: null,
            selected: false,
          },
        });
      }
    }

    if (
      nextProps.errorMsg.length > 0 &&
      !isEqual(nextProps.errorMsg, this.state.errorMsg)
    ) {
      this.setState({ errorMsg: nextProps.errorMsg }, () => {
        if (this.form) {
          this.form.showError(
            this.refs['name'],
            this.state.errorMsg[0].error || this.state.errorMsg[0],
          );
        }
      });
    }

    if (
      !nextProps.isCreate &&
      !this.hasLoaded &&
      nextProps.item.regionId !== ''
    ) {
      this.hasLoaded = true;
      this.setState({
        region: {
          value: nextProps.item.regionId,
          text: nextProps.item.regionName,
          extensionValue: null,
          selected: false,
        },
      });
      if (nextProps.item.marketId) {
        this.setState({
          market: {
            value: nextProps.item.marketId,
            text: nextProps.item.marketName,
            extensionValue: null,
            selected: false,
          },
        });
      }
    }

    if (nextProps.selectListRegions.length) {
      this.setState({
        isFetchedRegion: true,
      });
    }

    if (nextProps.selectListMarkets.length) {
      this.setState({
        isFetchedMarket: true,
      });
    }
  }

  onChangeMap = mapState => {
    this.location.fullLocation = mapState.fullLocation;
    this.location.city = mapState.city;
    this.location.state = mapState.state;
    this.location.postalCode = mapState.postalCode;
  };

  mapParam() {
    if (!this.form) {
      return {};
    }
    let param = this.form.getValues();
    param['status'] = true; //this.state.project.status;
    param['emergencyPhone'] = this.emergencyPhone.state.value;
    param['fullLocation'] = this.location.fullLocation;
    param['city'] = this.location.city;
    param['state'] = this.location.state;
    param['postalCode'] = this.location.postalCode;
    param['projectOwnerId'] = this.state.selectedOwner
      ? this.state.selectedOwner.value
      : '';

    if (
      AppSettings.REGION_AND_MARKET ===
      AppSettings.RegionAndMarket.REGION_AND_MARKET
    ) {
      param['regionId'] = this.state.region ? this.state.region.value : '';
      param['marketId'] = this.state.market ? this.state.market.value : '';
    }

    if (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION) {
      param['regionId'] = this.state.region ? this.state.region.value : '';
    }

    return param;
  }

  onSubmit = e => {
    this.setState({ errorMsg: [], nameNochanged: false })
    const data = this.mapParam();

    if (data.fullLocation && !data.state) {
      this.setState({
        error: 'Invalid location. Please pick a location from the list.',
      });
    } else {
      this.setState({ error: null });
      if (this.props.isCreate) {
        this.props.onSubmit(
          e,
          data,
          ProjectActionType.CREATE_PROJECT_ASYNC,
          true,
        );
      } 
      else if(this.props.item.name !== data.name) {
        this.setState({ confirmationModal: true });
      }
      else{
        this.props.onSubmit(
          e,
          data,
          ProjectActionType.UPDATE_PROJECT_ASYNC,
          false,
        );
      }
    }
    e.preventDefault();
  };

  updateProjectDetails=(e)=>{
    this.setState({ confirmationModal: false })
    const data = this.mapParam();
    this.props.onSubmit(
      e,
      data,
      ProjectActionType.UPDATE_PROJECT_ASYNC,
      false,
    );

    e.preventDefault();
  }
 
  onClickNO=(e)=>{
    let { project } = this.state;
    this.setState({ confirmationModal: false, nameNochanged: true })
    const data = this.mapParam();
    data.name = this.props.item.name
    project.name = this.props.item.name
    this.props.onSubmit(
      e,
      data,
      ProjectActionType.UPDATE_PROJECT_ASYNC,
      false,
    ) 
    e.preventDefault();
  }

  onclose=()=>{
    this.setState({ confirmationModal: false,nameNochanged: true })
  }

  editInfoConfimationModal = () =>{
    return (
      <Modal   
        centered="true"
        size="sm"
        show={this.state.confirmationModal}
      >
        <Modal.Header>
          <Modal.Title>
          Are you sure you want to update project name?

            <button type="button" className="close" aria-label="Close"  onClick={this.onclose} style={{float: "right"}}>
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Editing a project name will display all existing RFS with new name</p> <br />
          <p>After updating the project name and creating a new RFS with new project name the system will update all the RFS and WO with new project name in project details.</p> <br />
          {/* <h6> No -  We will save everything other than project name.</h6> */}
        </Modal.Body>
        <Modal.Footer>
          <div className="suspend-group-btn" >
          {/* <button
              style={{ float: "left" }}
              className="btn btn-primary btn-siteone-default btn-xs"
              onClick={this.onclose}
            >Cancel
            </button> */}
            <button
              className="btn btn-primary btn-siteone-default btn-xs"
              onClick={this.onclose}
            >Cancel
            </button>
            <button
              style={{ marginLeft: 10 }}
              className="btn btn-primary btn-siteone btn-xs"
              onClick={this.updateProjectDetails}
            >Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  onChangeRegionMarket = (e, type) => {
    this.setState({
      [type]: e.value,
    });
    if (type === 'region') {
      this.setState({
        market: null,
      });
    }
  };

  onFetchRegion = () => {
    this.props.onBindingRegion();
  };

  onFetchMarket = () => {
    const regionId = this.state.region ? this.state.region.value : null
    this.props.onBindingMarket(regionId);
  };

  onErrorPhoneNumber = status => {
    this.setState({
      errorPhoneNumber: status,
    });
  };

//   onCheckDuplicates(array) {
//     return (new Set(array)).size !== array.length;
// }

  onChangeTags(tags) {
    let tagsValid = [];
    let {costCodeArr} = this.state;
    let value = costCodeArr;    
    tags.map(tag => {
        tagsValid.push(tag);
    });
    this.setState(prevState => ({
      costCodeArr: tagsValid,
      project: {
          ...prevState.project,
          costCode: value.join('|')
      }
  }))

  // if(this.onCheckDuplicates(tagsValid)){
  //   this.setState({
  //     costCodeArr: value,
  //     errorMessage: 'Duplicate Cost code/account'
  //   })
  // } else {
  //   this.setState(prevState => ({
  //     costCodeArr: tagsValid,
  //     project: {
  //         ...prevState.project,
  //         costCode: value.join('|')
  //     },
  //     errorMessage: ''
  // }))
  // }
  
  }

  renderRegionAndMarket(isBuilderUser) {
    if (
      AppSettings.REGION_AND_MARKET ===
      AppSettings.RegionAndMarket.REGION_AND_MARKET
    ) {
      return (
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>
                <Translate translateKey='region' capitalize />{' '}
                <span className='text-danger'>*</span>
              </label>
              <Dropdown
                onChange={ref => this.onChangeRegionMarket(ref, 'region')}
                className='filestring-dropdown filter-dropdown'
                value={this.state.region}
                options={
                  this.props.isCreate
                    ? this.props.selectListRegions
                    : this.state.isFetchedRegion
                    ? this.props.selectListRegions
                    : [{ ...this.state.region }]
                }
                optionLabel='text'
                style={{ width: '100%' }}
                onRemote={this.onFetchRegion}
                disabled={isBuilderUser}
                placeholder='-- Please select'
              />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>
                <Translate translateKey='market' capitalize />{' '}
                <span className='text-danger'>*</span>
              </label>
              <Dropdown
                onChange={ref => this.onChangeRegionMarket(ref, 'market')}
                className='filestring-dropdown filter-dropdown'
                value={this.state.market}
                options={
                  this.props.isCreate
                    ? this.props.selectListMarkets
                    : this.state.isFetchedMarket
                    ? this.props.selectListMarkets
                    : [{ ...this.state.market }]
                }
                disabled={!this.state.region}
                optionLabel='text'
                style={{ width: '100%' }}
                onRemote={this.onFetchMarket}
                disabled={isBuilderUser}
                placeholder='-- Please select'
              />
            </div>
          </div>
        </div>
      );
    }

    if (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION) {
      return (
        <div className='form-group'>
          <label>
            <Translate translateKey='region' capitalize />{' '}
            <span className='text-danger'>*</span>
          </label>
          <Dropdown
            onChange={ref => this.onChangeRegionMarket(ref, 'region')}
            className='filestring-dropdown filter-dropdown'
            value={this.state.region}
            options={
              this.props.isCreate
                ? this.props.selectListRegions
                : this.state.isFetchedRegion
                ? this.props.selectListRegions
                : [{ ...this.state.region }]
            }
            optionLabel='text'
            style={{ width: '100%' }}
            onRemote={this.onFetchRegion}
            placeholder='-- Please select'
          />
        </div>
      );
    }

    return null;
  }

  onChangeOwner = event => {
    this.setState({ selectedOwner: event.value });
  };

  onFetchOwners = () => {
    this.setState({ loading: true });
    this.props.onBindingAccount({ searchKey: '', selectedValue: '' });
  };

  handleStatus = event => {
    let { project } = this.state;
    project.status = event.target.value === 'active' ? true : false;
    this.setState({ project });
  };

  onGetOwnerOptions = () => {
    const { item, isCreate, selectListAccounts } = this.props;

    if (
      !isCreate &&
      item.projectOwner &&
      item.projectOwner.id &&
      !selectListAccounts.some(x => x.value === item.projectOwner.id)
    ) {
      return [
        ...selectListAccounts,
        {
          value: item.projectOwner.id,
          text: item.projectOwner.displayName,
          extensionValue: null,
          selected: false,
        },
      ];
    }

    return selectListAccounts;
  };

  render() {
    let disabled = false;
    if (
      AppSettings.REGION_AND_MARKET ===
      AppSettings.RegionAndMarket.REGION_AND_MARKET
    ) {
      disabled =
        !this.state.region || !this.state.market || !this.state.selectedOwner;
    }

    if (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.REGION) {
      disabled = !this.state.region || !this.state.selectedOwner;
    }

    if (AppSettings.REGION_AND_MARKET === AppSettings.RegionAndMarket.NONE) {
      disabled = !this.state.selectedOwner;
    }

    const isBuilderUser = auth.getRoleName() === AppSettings.BUILDER_USER;

    if (isBuilderUser) {
      disabled = true;
    }

    let { project, initialed } = this.state;
    let {project:{costCode}} =this.state;
    let values = this.mapParam();
    // if (this.props.isCreate) {
    //   project.name = values['name'] || '';
    // }
    project.name = values['name'] || project.name;
    project.costCode = values['costCode'] || project.costCode;
    project.emergencyPhone = values['emergencyPhone'] || project.emergencyPhone;
    if(this.state.nameNochanged == true){
      project.name = this.props.item.name;
    }
    
    const ownerOptions = this.onGetOwnerOptions();

    return (
      <div
        className={
          'box-form-body' + (!this.props.isCreate ? ' no-padding' : '')
        }
      >{this.editInfoConfimationModal()}
        <Form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.onSubmit}
        >
          <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
          {this.renderRegionAndMarket(isBuilderUser)}
          <div className='form-group'>
            <label>
              <Translate translateKey='project' capitalize /> name{' '}
              <span className='text-danger'>*</span>
            </label>
            <Input
              type='text'
              name='name'
              value={project.name}
              ref='name'
              placeholder='Project name'
              className='form-control'
              autoFocus
              max='200'
              maxLength='200'
              disabled={isBuilderUser}
              validations={[Vali.required]}
            />
          </div>
          <div className='form-group'>
            <label>Location</label>
            <PlacesWithStandaloneSearchBox
              fullLocation={
                this.location.fullLocation &&
                this.location.fullLocation !== project.fullLocation
                  ? this.location.fullLocation
                  : project.fullLocation
              }
              city={
                this.location.city && this.location.city !== project.city
                  ? this.location.city
                  : project.city
              }
              state={
                this.location.state && this.location.state !== project.state
                  ? this.location.state
                  : project.state
              }
              postalCode={
                this.location.postalCode &&
                this.location.postalCode !== project.postalCode
                  ? this.location.postalCode
                  : project.postalCode
              }
              isCreate={this.props.isCreate}
              disabled={isBuilderUser}
              onChange={this.onChangeMap}
            />
            {this.state.error && (
              <span className='text-danger'>{this.state.error}</span>
            )}
          </div>
          <div className='form-group'>
            <label>Cost center/account</label>
            <Input
              type='hidden'
              name='costCode'
              ref='costCode'
              maxLength='100'
              value={this.state.costCodeArr.join('|')}
              disabled={isBuilderUser}
              placeholder='Cost code'
              className='form-control'
            />
            <TagsInput
              value={this.state.costCodeArr}
              onChange={tags => {
                this.onChangeTags(tags, 0);
              }}
              inputProps={{ placeholder: this.props.isCreate ? 'Cost Center' : '' }}
              addKeys={[9, 13, 188]}
              addOnBlur
              onlyUnique
              validationRegex={/^[a-zA-Z0-9._-]{1,100}$/}
            />
            {/* {this.state.errorMessage && (
                      <span className='cls-danger help-block'>
                        {this.state.errorMessage}
                      </span>
                    )} */}
          </div>
          <div className='form-group'>
            <label>
              <Translate translateKey='project' capitalize /> owner{' '}
              <span className='text-danger'>*</span>
            </label>
            {this.props.sso ? (
              <Dropdown
                filter={true}
                onChange={ref => {
                  this.onChangeOwner(ref);
                }}
                className='filestring-dropdown filter-dropdown'
                value={this.state.selectedOwner}
                options={ownerOptions}
                optionLabel='text'
                style={{ width: '100%' }}
                onRemote={this.onFetchOwners}
                filterPlaceholder='Filter'
                placeholder='Select a user....'
                errorMessage='This information is required.'
                groupLabels={[
                  {
                    label: 'System users',
                    field: 'sso',
                    condition: [true],
                  },
                  {
                    label: 'Builder users',
                    field: 'sso',
                    condition: [false, null],
                  },
                ]}
                ref={ref => {
                  this.projectOwner = ref;
                }}
              />
            ) : (
              <Dropdown
                filter={true}
                onChange={ref => {
                  this.onChangeOwner(ref);
                }}
                className='filestring-dropdown filter-dropdown'
                value={this.state.selectedOwner}
                // options={
                //   this.props.isCreate
                //     ? this.props.selectListAccounts
                //     : [{ ...this.state.selectedOwner }]
                // }
                options={ownerOptions}
                optionLabel='text'
                style={{ width: '100%' }}
                onRemote={this.onFetchOwners}
                filterPlaceholder='Filter'
                placeholder='Select a user....'
                errorMessage='This information is required.'
                ref={ref => {
                  this.projectOwner = ref;
                }}
              />
            )}
          </div>
          {/*<div className='form-group' style={{ 'width': '500px', display: 'flex', flexDirection: 'row' }}>
          <label><Translate translateKey='project' capitalize /> status</label>
          <div className='pull-right' style={{ flex: 1, 'marginTop': '-10px', marginLeft: 15 }}>
            <div className='row'>
              <div className='col-md-3'>
                <Radio ref={c => { this.active = c; }}
                number={1}
                  label='Active'
                  name='status'
                  value='active'
                  onChange={this.handleStatus}
                  disabled={isBuilderUser}
                  checked={project.status} />
              </div>
              <div className='col-md-3'>
                <Radio ref={c => { this.inActive = c; }}
                  number={2}
                  label='Inactive'
                  name='status'
                  value='inActive'
                  onChange={this.handleStatus}
                  disabled={isBuilderUser}
                  checked={!project.status} />
              </div>
            </div>
          </div>
      </div>*/}
          <div className='form-group'>
            <label>Emergency phone</label>
            {this.props.isCreate ? <PhoneNumberInput
              ref={ref => {
                this.emergencyPhone = ref;
              }}
              onError={this.onErrorPhoneNumber}
              disabled={isBuilderUser}
            /> : <PhoneNumberInput
              ref={ref => {
                this.emergencyPhone = ref;
              }}
              value={project.emergencyPhone}
              onError={this.onErrorPhoneNumber}
              disabled={isBuilderUser}
            />}
            {/*<Input type='text'
            name='emergencyPhone'
            value={project.emergencyPhone}
            ref='emergencyPhone'
            placeholder='(xxx) xxx-xxxx'
            maxLength='20'
            disabled={isBuilderUser}
            className='form-control' />*/}
          </div>
          {this.props.isCreate && (
            <div className='form-group'>
              By creating this <Translate translateKey='project' />, I agree to
              the Terms and Conditions set forth in the Master Service Agreement
              between my company and SiteOne Services.
            </div>
          )}
          <div className='form-group no-margin'>
            {this.props.isCreate ? (
              <Submit
                className='btn btn-primary btn-siteone'
                disabled={disabled || this.state.errorPhoneNumber}
              >
                Create
              </Submit>
            ) : (
              <Submit
                className='btn btn-primary btn-siteone'
                disabled={disabled || this.state.errorPhoneNumber}
              >
                Save
              </Submit>
            )}
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-information.js